import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import SignupModal from "../Components/Pages/Signup";
import TermsModal from "../Components/Pages/Competition/Terms";
import { SignupModalProvider } from "../context/SignupModalContext";
import { TermsModalProvider } from "../context/TermsModalContext";
import { ToastProvider } from "../context/ToastContext";

const Layout = ({ children }) => {
  return (
    <SignupModalProvider>
      <TermsModalProvider>
        <ToastProvider>
          <div className="app-layout">
            <Header />
            <main>{children}</main>
            <Footer />
            <SignupModal />
            <TermsModal />
          </div>
        </ToastProvider>
      </TermsModalProvider>
    </SignupModalProvider>
  );
};

export default Layout;
